import { mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d86bfd1")

_pushScopeId("data-v-7d86bfd1")
const _hoisted_1 = { class: "input" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("label", _hoisted_1, [
    _createVNode("input", _mergeProps({ value: _ctx.modelValue }, _ctx.$attrs, {
      onChange: _cache[1] || (_cache[1] = $event => (_ctx.$emit('update:modelValue', $event.target.value)))
    }), null, 16, ["value"]),
    _createTextVNode(" " + _toDisplayString(_ctx.label), 1 /* TEXT */)
  ]))
})